import React, { useState } from "react";

export default function AvatarPicker({ employee, onChange, onClear, onClose }) {
    const [uploading, setUploading] = useState(false);

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        try {
            setUploading(true);

            const formData = new FormData();
            formData.append("file", file);
            formData.append("employeeId", String(employee?.id ?? employee?.name ?? "emp"));

            const res = await fetch("/api/upload/avatar", {
                method: "POST",
                body: formData,
            });

            if (!res.ok) {
                console.error("❌ Błąd uploadu:", await res.text());
                return;
            }

            const data = await res.json();
            if (data.url) onChange?.({ avatarUrl: data.url });
        } catch (err) {
            console.error("❌ Upload error:", err);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="p-4 sm:p-6">
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                    <span>🖼️</span>
                    <h3 className="text-lg font-semibold">Zdjęcie</h3>
                </div>
                <button
                    onClick={() => {
                        onClear?.();
                    }}
                    className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                >
                    Wyczyść
                </button>
            </div>

            <div className="flex items-center gap-4 mb-4">
                <div
                    className="rounded-full overflow-hidden border border-gray-700 bg-black/30"
                    style={{ width: 96, height: 96 }}
                >
                    {employee?.avatarUrl ? (
                        <img
                            src={employee.avatarUrl}
                            alt={employee?.name || "avatar"}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-gray-400">Brak</div>
                    )}
                </div>

                <label className="flex-1">
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        disabled={uploading}
                        className="block w-full bg-gray-800 border border-gray-600 rounded px-3 py-2"
                    />
                    <div className="text-xs text-gray-400 mt-1">
                        PNG/JPG/WebP do 2&nbsp;MB • przycinamy do kwadratu 256×256
                    </div>
                </label>
            </div>

            <div className="mt-4 flex justify-end">
                <button onClick={onClose} className="bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded">
                    Zamknij
                </button>
            </div>
        </div>
    );
}
